const TEXT_FIELD_TAGS = new Set(['INPUT', 'TEXTAREA', 'SELECT']);

/** The key went to something the player types into — a page-wide shortcut must let it be. */
export function isTypingTarget(target: EventTarget | null): boolean {
  return (
    target instanceof HTMLElement &&
    (target.isContentEditable || TEXT_FIELD_TAGS.has(target.tagName))
  );
}
